// Import variables from the theme
import { css } from '@emotion/react';

export default $ => css`
  .form-errors {
    position: fixed;
    right: 0.5rem;
    bottom: 0;
    max-width: 320px;
    width: 100%;
    border-radius: ${$.borderRadius} ${$.borderRadius} 0 0;
    background-color: ${$.white};
    z-index: 10;
    display: flex;
    flex-direction: column;
    max-height: 50vh;

    .card-header {
      background-color: ${$.primaryMain};
      color: ${$.white};
      font-weight: bold;
      position: relative;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;

      > .expandable {
        position: absolute;
        right: 26px;
        height: 1.5em;
        width: 1.5em;
        background-color: transparent;
        border-width: 0;
        color: ${$.white};

        > * {
          font-size: 2.5rem;
          line-height: 1.5rem;
        }
      }
    }

    .card-body {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }

    .form-error-list {
      overflow-y: auto;
      background-color: ${$.white};
      display: flex;
      flex-direction: column;
      margin-bottom: 0;

      .error-item {
        &:not(:first-of-type)::before {
          width: 75%;
          height: 1px;
          background-color: ${$.black};
          content: ' ';
          align-self: center;
        }

        &:first-of-type {
          border-radius: 4px 4px 0 0;
        }

        &:last-child {
          border-radius: 0 0 4px 4px;
        }

        display: flex;
        flex-direction: column;
        margin-bottom: 1px;
        color: ${$.black};
        text-align: left;

        > * {
          overflow-wrap: anywhere;
          color: ${$.black};
        }
      }
    }
  }
`;
